import Portal from 'components/portals/Portal'

const HeaderInputFieldPortal = ({ component }) => (
  <Portal elementId="portal-header-input" component={component} />
)

export default HeaderInputFieldPortal
